"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineMinimumPriceByKeyword = void 0;
var itemList_1 = require("../lib/itemList");
var minPriceList_1 = require("../lib/minPriceList");
var pavementTypeState_1 = require("./pavementTypeState");
var constructionState_1 = require("./constructionState");
var const_1 = require("../lib/const");
/**
 * 関数
 */
// pathにキーワードが含まれているかどうかをチェックする関数
var checkPathForKeywords = function (path, keywords) {
    for (var keyword in keywords) {
        if (path.includes(keyword)) {
            return { containsKeyword: true, matchedKeyword: keyword };
        }
    }
    return { containsKeyword: false, matchedKeyword: null };
};
// 舗装タイプを文字列に変換する関数
var convertPavementTypeToString = function (pavementType) {
    var _a;
    var pavementTypes = {
        0: '密粒舗装',
        1: '開粒舗装',
        2: 'コンクリート舗装'
    };
    return (_a = pavementTypes[pavementType]) !== null && _a !== void 0 ? _a : '';
};
// 選択されたアイテムの値を取得し配列にして返す関数
var getSelectedItemValues = function () {
    var selectedItems = document.querySelectorAll('.gfield[data-conditional-logic="visible"] .gpnf-nested-entries tbody tr td:first-child[data-heading]');
    return Array.from(selectedItems).map(function (element) { var _a; return (_a = element.getAttribute('data-value')) !== null && _a !== void 0 ? _a : ''; });
};
// 価格リストをフィルタリングする関数
var filterPriceList = function (type, pavementType, lineType, timeZone) {
    return minPriceList_1.minPriceList.filter(function (item) {
        return item.type === const_1.CONSTRUCTION_TYPE[type] && // 駐車場工事 | 道路工事
            item.pavementType === pavementType && // 密粒舗装 | 開粒舗装
            item.lineType === lineType && // 白 | 白黄
            item.timeZone === const_1.TIME_ZONE[timeZone];
    } // 昼 | 夜
    );
};
// 指定された価格より高い中で、最も近い価格を持つ工事データを返す
var findClosestHigherPrice = function (works, currentPrice) {
    // 基準価格より高い工事データのみをフィルタリング
    var higherPrices = works.filter(function (work) { return work.price >= currentPrice; });
    // 該当するデータがない場合は、配列内の最高額を返す
    if (higherPrices.length === 0) {
        return works.reduce(function (highest, current) {
            return current.price > highest.price ? current : highest;
        });
    }
    // フィルタリングされたデータの中から最小価格のものを返す
    return higherPrices.reduce(function (closest, current) {
        return current.price < closest.price ? current : closest;
    });
};
// キーワードに基づいて最小価格を決定する関数
// 戻り値は最小金額
// propsは現在の合計金額の値(number)をセットしてください。
var determineMinimumPriceByKeyword = function (props) {
    var _a, _b, _c, _d;
    console.log('determineMinimumPriceByKeyword');
    // 現在のpathを取得
    var currentPath = window.location.pathname;
    // 現在のpathに特定のキーワードが含まれているかどうかをチェック
    var _e = checkPathForKeywords(currentPath, const_1.CONSTRUCTION_TYPE), containsKeyword = _e.containsKeyword, matchedKeyword = _e.matchedKeyword;
    // 現在のpathに特定のキーワードが含まれていない場合は、DEFAULT_MIN_PRICEを返す
    if (!containsKeyword || matchedKeyword === null) {
        console.error('キーワードが取得できません');
        return const_1.DEFAULT_MIN_PRICE;
    }
    // 舗装の種類を取得して、変数に格納
    var pavementType = convertPavementTypeToString((0, pavementTypeState_1.fetchPavementTypeState)());
    // 施工の時間帯を取得して、変数に格納。デフォルトは昼
    var constructionState = (_a = (0, constructionState_1.fetchConstructionState)()) !== null && _a !== void 0 ? _a : '0';
    if (pavementType === '' || constructionState === '') {
        console.error('舗装の種類または施工の時間帯が取得できません');
        return const_1.DEFAULT_MIN_PRICE; // 舗装の種類が取得できなかった場合は、DEFAULT_MIN_PRICEを返す
    }
    // 選択された要素から、data-value属性の値を取得。
    // ex: ['溶融式　(白)W＝10㎝)', '身障者マーク　溶解式(白)1500×1000']
    var headingValues = getSelectedItemValues();
    // 該当する工事データをフィルタリング
    var matchedLineItems = itemList_1.lineItems.filter(function (item) {
        return headingValues.includes(item.specification) &&
            item.pavementType === pavementType;
    });
    // 一式【白】があるかの判定
    var hasWhiteSet = matchedLineItems.some(function (item) { return item.whiteSet; });
    // 一式【白黄】があるかの判定
    var hasWhiteYellowSet = matchedLineItems.some(function (item) { return !item.whiteSet && item.whiteYellowSet; });
    // 一式【白】がある場合
    if (hasWhiteSet && !hasWhiteYellowSet) {
        // console.log(
        //   'hasWhiteSet',
        //   filterPriceList(
        //     matchedKeyword,
        //     pavementType,
        //     LINE_TYPE.WHITE,
        //     constructionState
        //   )
        // )
        return ((_c = (_b = findClosestHigherPrice(filterPriceList(matchedKeyword, pavementType, const_1.LINE_TYPE.WHITE, constructionState), props)) === null || _b === void 0 ? void 0 : _b.price) !== null && _c !== void 0 ? _c : const_1.DEFAULT_MIN_PRICE);
    }
    // 一式【白黄】がある場合。※【白】と【白黄】の両方がある場合は、【白黄】を優先
    if (hasWhiteYellowSet || (hasWhiteSet && hasWhiteYellowSet)) {
        // console.log(
        //   'hasWhiteYellowSet',
        //   filterPriceList(
        //     matchedKeyword,
        //     pavementType,
        //     LINE_TYPE.WHITE_YELLOW,
        //     constructionState
        //   )[0].price
        // )
        // 白黄の場合は、条件が一つだけなので、0番目の価格を返す
        return ((_d = filterPriceList(matchedKeyword, pavementType, const_1.LINE_TYPE.WHITE_YELLOW, constructionState)[0].price) !== null && _d !== void 0 ? _d : const_1.DEFAULT_MIN_PRICE);
    }
    console.info('最後まで処理されました');
    return const_1.DEFAULT_MIN_PRICE;
};
exports.determineMinimumPriceByKeyword = determineMinimumPriceByKeyword;
